import React from 'react';
import Base from './Base';

function UnknownGameEvent({ event, periods }) {
  const period = periods[event.period].name;
  return (
    <Base
      time={event.second}
      period={period}
      type="Unknown"
    >
      {JSON.stringify(event)}
    </Base>
  )
}

export default UnknownGameEvent;
